import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        color: "rgba(255,255,255,0.1)",
      },
      ticks: {
        color: "#fff",
      },
    },
    y: {
      grid: {
        drawBorder: false,
        color: "rgba(255,255,255,0.1)",
      },
      ticks: {
        color: "#fff",
      },
    },
  },
};

const DepositConfirmations = ({ data, loading }) => {
  const [labels, setLabels] = useState({});
  const exchangedata2 = {
    labels: labels.labels,
    datasets: [
      {
        label: "Deposit Confirmations",
        data: labels.values,
        backgroundColor: labels.colors,
        borderColor: ["rgba(255,255,255,0.2)"],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    const GetLabels = (data) => {
      const labels = [];
      const values = [];
      const colors = [];
      let sorteddata = data.map((x) => x);
      sorteddata.sort((a, b) =>
        a.attributes.name.localeCompare(b.attributes.name)
      );
      sorteddata.sort(function (a, b) {
        return (
          a.attributes.deposit_confirmations -
          b.attributes.deposit_confirmations
        );
      });
      for (let i = 0; i < sorteddata.length; ++i) {
        if (sorteddata[i].attributes.deposit_confirmations !== null) {
          labels.push(sorteddata[i].attributes.name);
          values.push(sorteddata[i].attributes.deposit_confirmations);
          const confirmations = sorteddata[i].attributes.deposit_confirmations;
          if (confirmations > 1) {
            colors.push("#af0707");
          } else if (confirmations === 1) {
            colors.push("#0d1014");
          } else {
            colors.push("#0671c0");
          }
        }
      }
      return { labels: labels, values: values, colors: colors };
    };
    setLabels(GetLabels(data));
  }, [data]);

  return (
    <>
      <h2>Deposit Confirmations</h2>
      <Bar options={options} data={exchangedata2} />
    </>
  );
};

export default DepositConfirmations;
